import { render, staticRenderFns } from "./assets-home.vue?vue&type=template&id=3962c9f3&scoped=true&"
import script from "./assets-home.vue?vue&type=script&lang=ts&"
export * from "./assets-home.vue?vue&type=script&lang=ts&"
import style0 from "./assets-home.vue?vue&type=style&index=0&id=3962c9f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3962c9f3",
  null
  
)

export default component.exports